export default __webpack_public_path__ + "static/media/wowza.9c5dbf0d.svg";